module.exports = __webpack_public_path__ + "img/account-admin.84034a7a.svg";